module.exports = __webpack_public_path__ + "static/media/bizmerlin.dbbe9989.png";